import {TextareaHTMLAttributes} from 'react';
import {FieldError, UseFormRegister} from 'react-hook-form';

import {cn} from '@/lib/utils';

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  register?: UseFormRegister<any>;
  name: string;
  className?: string;
  inputClassName?: string;
  label: string;
  error?: FieldError | undefined;
};

export default function TextArea({
  className,
  inputClassName = '',
  label,
  name,
  register,
  error,
  ...props
}: Props) {
  return (
    <div className={cn('flex flex-col', className)}>
      <label
        className="text-sm text-gray-700 leading-[1.8] w-fit"
        htmlFor={name}>
        {label}
      </label>
      <textarea
        id={name}
        rows={6}
        {...register?.(name)}
        className={`apperance-none min-h-[44px] w-full rounded-none py-2 px-4 text-md leading-[1.625] text-graphite flex  bg-gray-100 border border-gray-200 focus:border-primary outline-none ${inputClassName}`}
        {...props}
      />
      {error && (
        <i className="text-error-primary font-averta-italic text-xs mt-2">
          {error.message?.toString()}
        </i>
      )}
    </div>
  );
}
